import "./App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ComingSoon } from "./pages/ComingSoon";
import { Adresseingabe } from "./pages/Adresseingabe";
import { AusweisNachreichen } from "./pages/AusweisNachreichen";

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a1128",
            color: "#ffffff",
            border: "1px solid #1a2342",
            borderRadius: "4px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <Routes>
        <Route path="/adresseingabe" element={<Adresseingabe />} />
        <Route path="/ausweis-nachreichen" element={<AusweisNachreichen />} />
        <Route path="*" element={<ComingSoon />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
